CF.customerReady(async function() {
  fieldChangeHandler();
  document.querySelector('.measurements')?.querySelectorAll('select').forEach(select => {
    // NiceSelect.bind(select, {  })
  })
});

function fieldChangeHandler() {
  document.querySelectorAll('.js-field-change').forEach(fieldCheckbox => {
    fieldCheckbox.addEventListener('click', () => {
      const field = fieldCheckbox.closest('.js-field');
      const input = field.querySelector('.input');
      input.classList.toggle('hidden');
      input.disabled ? input.removeAttribute('disabled') : input.setAttribute('disabled', true);
    })
  })
}

// document.addEventListener('DOMContentLoaded', () => { });

class DatePicker extends HTMLElement {
  constructor() {
    super();
    this.dateSelects = document.querySelectorAll('.js-date-select');
    this.dateCombinedInput = this.querySelector('.js-date-combined');
    this.daySelect = this.querySelector('[data-name="day"]');
    this.monthSelect = this.querySelector('[data-name="month"]');
    this.yearSelect = this.querySelector('[data-name="year"]');
    this.currentDate = this.dataset.currentDate;

    this.dateSelects.forEach(dateSelect => {
      dateSelect.addEventListener('change', (e) => {
        console.log(dateSelect.name, dateSelect.value);
        const day = this.daySelect.value || this.daySelect.min || 1;
        const month = this.monthSelect.value || this.monthSelect.min || 1;
        const year = this.yearSelect.value || this.yearSelect.min || 1900;
        this.dateCombinedInput.value = new Date(`${month}-${day}-${year}`);
        console.log(this.dateCombinedInput.value);
      })
    });
  }
  connectedCallback() {
    if (this.currentDate) {
      const current_date = new Date(this.currentDate);
      this.daySelect.selectedIndex = current_date.getDate();
      this.monthSelect.selectedIndex = current_date.getMonth() + 1;
      this.yearSelect.selectedIndex = Array.from(this.yearSelect.querySelectorAll('option')).findIndex(option => option.value == current_date.getFullYear());
      this.dateCombinedInput.value = current_date;
    }
  }
}

customElements.define('date-picker', DatePicker);

class AccountMenu extends HTMLElement {
  constructor() {
    super();
    this.links = this.querySelectorAll('a');
    this.ordersLink = this.querySelector('.js-orders-link');
    this.addressLink = this.querySelector('.js-address-link');
    this.links.forEach(link => {
      link.addEventListener('click', (e) => {
      })
    })
    window.addEventListener("hashchange", () => this.refresh());

  }


  connectedCallback() {

    let activeLink;
    if (window.location.pathname.includes('/orders')) {
      activeLink = this.ordersLink;
    }
    else if (window.location.pathname.includes('/addresses')) {
      activeLink = this.addressLink;
    }
    else if (!window.location.hash) {
      activeLink = this.links[0];
    }
    
    this.refresh(activeLink);

  }
  toggle() {
    this.classList.toggle('opened');
    document.querySelectorAll('.account-content').forEach(content => content.classList.toggle('visibility-hidden'));
  }
  hide() {
    this.classList.remove('opened');
    document.querySelectorAll('.account-content').forEach(content => content.classList.remove('visibility-hidden'));
  }
  refresh(activeLink) {
    this.links.forEach(link => link.classList.remove('active'));
    if (!activeLink) {
      activeLink = Array.from(this.links).find(link => '#'+link.href.split('#')[1] === window.location.hash);
    }
    if (activeLink) {
      activeLink.classList.add('active')
      document.querySelector('.js-menu-opener').innerText = activeLink.innerText;
      this.hide();
    }
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
}
customElements.define('account-menu', AccountMenu);
